class FeedsCtrl {

    constructor($scope, $routeParams, $uibModal, ApiService, CONTENT_TYPE, EVENTS, $rootScope) {

        this.$scope = $scope;
        $scope.advertiser = null;
        $scope.feeds = null;
        $scope.feed = null;
        $scope.loading = true;
        this.$routeParams = $routeParams;
        this.ApiService = ApiService;
        this.$uibModal = $uibModal;
        this.contentType = CONTENT_TYPE.FEED;
        this.$scope.tableSort = 'name';
        this.EVENTS = EVENTS;

        $scope.accountId = this.$routeParams.accountId;
        $scope.advertiserId = this.$routeParams.advertiserId;

        $scope.loading = true;
        $scope.noResults = false;
        $scope.error = false;

        $scope.errorMessage = '';

        ApiService.get(CONTENT_TYPE.ADVERTISER, $routeParams.advertiserId) 
            .then((response) => {
                $scope.advertiser = response.data;
                $scope.$emit(EVENTS.SET_TITLE, $scope.advertiser.name);
            }, (response) => {
                console.error(response);
                $scope.error = true;
            });

        this.$scope.addFeed = this.addFeed.bind(this);
        this.$scope.refreshFeeds = this.refreshFeeds.bind(this);
        this.$scope.updateFeed = this.updateFeed.bind(this);
        this.$scope.deleteFeed = this.deleteFeed.bind(this);
        this.$scope.sortTable = this.sortTable.bind(this);
        this.$scope.copy = this.copy.bind(this);
        this.$scope.refreshFeeds();

        $rootScope.$on(this.EVENTS.COPY_COMPLETE, (event, entity) => {
            if(entity.advertiserId == this.$scope.advertiserId) {
                this.refreshFeeds();
            }
        });
    }

    copy(feed) {

        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'components/copy-entity-modal.html',
            controller: 'CopyEntityCtrl',
            resolve: {
                entity: () => feed,
                multiple: () => false,
                title: () => "Choose advertiser to copy " + feed.name + " to..."
            }
        });
    }

    sortTable(key) {
        if (this.$scope.tableSort === '-' + key) {
            this.$scope.tableSort = key;
        } else {
            this.$scope.tableSort = '-' + key;
        }
    }

    addFeed() {
        var self = this;
        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'feed/add-feed.html',
            controller: 'AddItemCtrl',
            resolve: {
            }
        });
        modalInstance.result.then((newItem) => {
            this.createFeed(newItem);
        }, () => {

        });

    }

    updateFeed(newItem) {
        let feed = {
            feedId: newItem.id,
            name: newItem.name
        };

        this.ApiService.update(this.contentType, feed)
            .then((response) => {
                this.refreshFeeds();
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
        });
    }

    createFeed(newItem) {
        let feed = {
            feedId: this.feedId,
            advertiserId: this.$scope.advertiser.id,
            name: newItem.name
        };

        this.ApiService.create(this.contentType, feed)
            .then((response) => {
                this.refreshFeeds();
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
            });
    }

    deleteFeed(feed) {
        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {
            this.ApiService.delete(this.contentType, feed.id)
                .then((response) => {
                    this.refreshFeeds();
                }, (response) => {
                    console.error(response);
                    this.$scope.error = true;
                });
        },() => {
            // NOOP
        });
    }

    refreshFeeds() {
        this.$scope.noResults = false;
        this.$scope.loading = true;
        this.ApiService.list(this.contentType, "advertiser=" + this.$scope.advertiserId)
            .then((response) => {
                this.$scope.feeds = response.data;
                this.$scope.loading = false;
                if (this.$scope.feeds.length === 0) {
                    this.$scope.noResults = true;
                }
            }, (response) => {
                this.$scope.feeds = [];
                if (response.status === 404) {
                    this.$scope.noResults = true;
                } else {
                    console.error(response);
                    this.$scope.error = true;
                }
                this.$scope.loading = false;
            });
    }

}


angular.module("cpm").controller("FeedsCtrl", ['$scope', '$routeParams', '$uibModal', 'ApiService', 'CONTENT_TYPE', 'EVENTS', '$rootScope', FeedsCtrl]);
